import { useRef } from 'react';

type Filters<K> = K extends ReadonlyArray<string> ? Record<K[number], any> : Record<string, never>;

export function initializeFilters<K>(keysList?: K): Filters<K> {
    if (!Array.isArray(keysList)) {
        return {} as Filters<K>;
    }

    return keysList.reduce((map, key) => {
        map[key] = undefined;
        return map;
    }, {} as Filters<K>);
}

function useInitialFilters(keys?: ReadonlyArray<string>) {
    const initialFilters = useRef(initializeFilters(keys));

    return initialFilters.current;
}

export default useInitialFilters;
